import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  as: Component = 'div'
}) => {
  return (
    <Component
      className={`
        w-full
        px-4 sm:px-6 lg:px-8
        mx-auto
        max-w-7xl
        ${className}
      `.trim()}
    >
      {children}
    </Component>
  );
};

export default Container;
